const fixture = {
  onSearch: () => {},
  searchResults: ["testresult1", "testresult2"],
};

export default fixture;
